class StickyInfoLock extends HTMLElement {
  static LOCK_CLASS = 'scroll-y-off';
  static TARGET_SELECTOR = 'product-info';

  frozen = new Map();

  connectedCallback() {
    this.bodyObserver = new MutationObserver(this.onBodyChange);
    this.bodyObserver.observe(document.body, { attributes: true, attributeFilter: ['class'] });
    this.styleObserver = new MutationObserver(this.onStyleChange);
  }

  disconnectedCallback() {
    this.bodyObserver?.disconnect();
    this.release();
  }

  get isLocked() {
    return document.body.classList.contains(StickyInfoLock.LOCK_CLASS);
  }

  onBodyChange = () => {
    if (this.isLocked && !this.frozen.size) this.freeze();
    else if (!this.isLocked && this.frozen.size) this.release();
  };

  freeze() {
    document.querySelectorAll(StickyInfoLock.TARGET_SELECTOR).forEach((info) => {
      if (!info.style.top) return;
      this.frozen.set(info, info.style.top);
      this.styleObserver.observe(info, { attributes: true, attributeFilter: ['style'] });
    });
  }

  release() {
    this.styleObserver?.disconnect();
    this.frozen.clear();
  }

  onStyleChange = () => {
    this.frozen.forEach((top, info) => {
      if (info.style.top !== top) info.style.top = top;
    });
    this.styleObserver.takeRecords();
  };
}

if (!customElements.get('sticky-info-lock')) {
  customElements.define('sticky-info-lock', StickyInfoLock);
}
